import { render, staticRenderFns } from "./FontStyleEditor.vue?vue&type=template&id=b064c846&"
import script from "./FontStyleEditor.vue?vue&type=script&lang=js&"
export * from "./FontStyleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports